var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppLayout',{staticClass:"resources-list-page-template"},[_c('Row',{attrs:{"type":"flex","justify":"center"}},[_c('Col',{attrs:{"span":24}},[_c('ProfileInfoFieldsOthers')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }